import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { CommonDataModel } from 'src/app/shared/common-data-model';
import { CommonConstants } from '../constants/common-constants';
import { CommonService } from '../services/common.service';
import { CustomToastrService } from '../services/custom-toastr-service';
import { isArray, isNumber, isObject } from 'util';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { CommonDialogComponent } from 'src/app/shared/common-dialog/common-dialog.component';
import { MatDialog } from '@angular/material';

@Injectable({
    providedIn: 'root'
})

export class CommonMethod {

    commonDataModel = new CommonDataModel();
    loggedUserModel = this.commonDataModel.loggedUserModel;

    private bolInstructionSubject = new BehaviorSubject(false);
    bolInstructionValue = this.bolInstructionSubject.asObservable();

    private vendorBookingStartupPage = new BehaviorSubject<string>('');
    getVendorBookingStartupPage = this.vendorBookingStartupPage.asObservable();

    private setLocationRequiredServices = new BehaviorSubject(false);
    getLocationRequiredServices = this.setLocationRequiredServices.asObservable();

    private setVendorTrackingDisplayMode = new BehaviorSubject<string>('');
    getVendorTrackingDisplayMode = this.setVendorTrackingDisplayMode.asObservable();

    private setVendorItemFormDirty = new BehaviorSubject(false);
    getVendorItemFormDirty = this.setVendorItemFormDirty.asObservable();

    private setVendorItemExit = new BehaviorSubject(false);
    getVendorItemExit = this.setVendorItemExit.asObservable();

    constructor(
        private matDialog: MatDialog,
        private toastr: ToastrService,
        private commonService: CommonService,
        private customToastrService: CustomToastrService) {
        this.loggedUserModel = this.commonService.getLoggedUserData();
    }

    sendBolInformationData(value: boolean) {
        this.bolInstructionSubject.next(value);
    }

    sendVendorBookingStartupPage(data: any) {
        this.vendorBookingStartupPage.next(data);
    }

    sendLocationRequiredServices(value: boolean) {
        this.setLocationRequiredServices.next(value);
    }

    sendVendorTrackingDisplayMode(data: string) {
        this.setVendorTrackingDisplayMode.next(data);
    }

    sendVendorItemFormDirty(value: boolean) {
        this.setVendorItemFormDirty.next(value);
    }

    sendVendorItemExit(value: boolean) {
        this.setVendorItemExit.next(value);
    }

    // Object Mapping
    objectMapping(mappingObject: object, sourceObject: object) {
        Object.keys(sourceObject).map((key, index) => {
            if (mappingObject.hasOwnProperty(key)) {
                mappingObject[key] = _.cloneDeep(sourceObject[key]);
            }
        });
    }

    async imageFileUploadValidation(event: any, claimsFormDocument?: boolean) {
        let uploadFileModel = _.cloneDeep(this.commonDataModel.uploadFileModel);
        if (event.target.files && event.target.files.length > 0) {
            const fileSizeLimit = claimsFormDocument ? 5000000 : 2000000
            if (event.target.files[0].size <= fileSizeLimit) {
                let file = event.target.files[0];
                const extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
                const isExtensionValid = claimsFormDocument ? this.checkDocumentFileExtension(extension) : this.checkImageFileExtension(extension);
                if (isExtensionValid) {
                    uploadFileModel.isFileValid = true;
                    uploadFileModel.fileName = file.name;
                    uploadFileModel.file = file;
                    uploadFileModel.fileSize = this.formatFileSize(file.size, 1);
                    uploadFileModel.base64Url = await this.convertFileToBase64(file);
                } else {
                    file = '';
                    uploadFileModel = _.cloneDeep(this.commonDataModel.uploadFileModel);
                    this.customToastrService.error(CommonConstants.appConstant.invalidFileFormat);
                }
            } else {
                uploadFileModel = _.cloneDeep(this.commonDataModel.uploadFileModel);
                this.customToastrService.error(`${CommonConstants.appConstant.imageFileSizeMessage} ${claimsFormDocument ? ' 5 MB.' : ' 2 MB.'}`);
            }
            return uploadFileModel;
        }
    }

    convertFileToBase64 = (file: any) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    })

    checkImageFileExtension(fileType: any) {
        const inputType = fileType.toLowerCase();
        const imageFileExtensionList = ['png', 'jpeg', 'bmp', 'jpg', 'svg'];
        return imageFileExtensionList.includes(inputType);
    }

    checkDocumentFileExtension(fileType: any) {
        const inputType = fileType.toLowerCase();
        const imageFileExtensionList = ['pdf', 'tif', 'png', 'jpeg', 'jpg'];
        return imageFileExtensionList.includes(inputType);
    }

    formatFileSize(bytes: number, decimalPoint: number) {
        if (bytes === 0) { return '0 Bytes'; }
        const dm = decimalPoint || 1;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return parseFloat((bytes / Math.pow(1024, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    copyClipboard(value: any): void {
        const textAreaInput = document.createElement('textarea');
        textAreaInput.style.opacity = '0';
        textAreaInput.value = value;
        document.body.appendChild(textAreaInput);
        textAreaInput.focus();
        textAreaInput.select();
        document.execCommand('copy');
        textAreaInput.setSelectionRange(0, 0);
        document.body.removeChild(textAreaInput);
    }

    copyClipboardFromInput(inputElement: any): void {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }

    mapCarrierTrackingLink(dataItem: any, type = true) {
        if (dataItem.carrierTrackingLink) {
            let proValue = '0';
            if (type && dataItem.carrierInfo) {
                proValue = dataItem.carrierInfo.pro ? dataItem.carrierInfo.pro : '0';
            } else {
                proValue = dataItem.pro ? dataItem.pro : '0';
            }
            return dataItem.carrierTrackingLink.replace('{0}', proValue);
        }
    }

    showCarrierTrackingLink(dataItem: any, type = true) {
        if (dataItem.mode === CommonConstants.moduleName.parcel) {
            if (dataItem.carrierTrackingLink) {
                return true;
            }
            return false;
        }
        else {
            if (type && dataItem.carrierInfo) {
                if (dataItem.carrierTrackingLink && dataItem.carrierInfo.pro && dataItem.mcNumber) {
                    return true;
                }
                return false;
            } else {
                if (dataItem.carrierTrackingLink && dataItem.pro && dataItem.mcNumber) {
                    return true;
                } else if (dataItem.carrierTrackingLink && dataItem.carrierTrackingLink.includes('tive')) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    switchToSingleClass(sourceObject: any, isCopiedShipment?: boolean) {
        const items = _.cloneDeep(sourceObject[0].items);
        const data = {
            itemId: sourceObject[0].itemId,
            quantity: null,
            handlingUnitType: sourceObject[0].handlingUnitType,
            weight: null,
            length: null,
            width: null,
            height: null,
            totalWeight: sourceObject[0].totalWeight,
            totalVolume: sourceObject[0].totalVolume,
            totalDensity: sourceObject[0].totalDensity,
            totalValue: sourceObject[0].totalValue,
            totalItems: sourceObject[0].totalItems,
            isNestedItems: false,
            searchBoxHandlingUnitType: sourceObject[0].searchBoxHandlingUnitType,
            items: []
        };
        if (isCopiedShipment) {
            const list = [];
            const copiedItems = _.cloneDeep(sourceObject);
            const length = sourceObject.length;
            sourceObject.splice(0, length);
            copiedItems.filter((element: any) => {
                element.items.filter((item: any, index: number) => {
                    if (index !== items.length) {
                        const result = _.cloneDeep(data);
                        result.items.push(item);
                        list.push(result);
                    }
                });
            });
            list.filter((item: any) => {
                sourceObject.push(item);
            });
        } else {
            items.filter((item: any, index: number) => {
                if (index !== items.length) {
                    const result = _.cloneDeep(data);
                    result.items.push(item);
                    sourceObject.push(result);
                }
            });
            sourceObject.splice(0, 1);
        }
    }

    switchToMulticlass(sourceObject: any) {
        const shipmentItems = _.cloneDeep(sourceObject);
        const itemList = [];
        shipmentItems.map((list: any) => {
            list.items.map((item: any, itemIndex: number) => {
                itemList.push(item);
            });
        });
        sourceObject[0].quantity = 1;
        sourceObject[0].items = itemList;
        sourceObject[0].isNestedItems = true;
        sourceObject.splice(1, shipmentItems.length);
    }

    checkResidentialCheckbox(checkBoxName: any, checkBoxValue: any) {
        if (checkBoxName === CommonConstants.residentialCheckboxStatus.residential) {
            return checkBoxValue ? false : true;
        } else if (checkBoxName === CommonConstants.residentialCheckboxStatus.nonResidential) {
            return checkBoxValue === false ? false : true;
        } else {
            return checkBoxValue === null ? false : true;
        }
    }

    showRequiredServices(moduleName: string, serviceName: string, item: any) {
        const serviceList = _.compact(item);
        if (CommonConstants.moduleName.scheduleShipment === moduleName || CommonConstants.moduleName.scheduleTruckload === moduleName) {
            if (serviceName && !_.isEmpty(serviceList)) {
                return true;
            }
            return false;
        }
    }

    calculateNestedItemVolumeAndDensity(list: any) {
        list.items.filter(item => {
            if (item.quantity && item.width && item.height && item.length) {
                item.volume = parseFloat((item.width * item.height * item.length * item.quantity / 1728).toFixed(2));
                if (item.weight && item.volume) {
                    item.density = parseFloat((item.weight / item.volume).toFixed(2));
                } else {
                    item.density = 0;
                }
            } else {
                item.volume = 0;
                item.density = 0;
            }
        });
    }

    shipmentItemValueMapping(sourceData: any, result: any) {
        const data = Object.assign({}, result);
        data.length = (result.length === 0 ? null : result.length);
        data.width = (result.width === 0 ? null : result.width);
        data.height = (result.height === 0 ? null : result.height);
        data.value = (result.value === 0 ? null : result.value);
        data.pieces = (result.pieces === 0 ? null : result.pieces);
        data.handlingType = result.packageType;
        if (data.freightClass) {
            data.freightClass = data.freightClass.toString();
        }
        if (data.minTemperature === 0) {
            data.minTemperature = null;
        }
        if (data.maxTemperature === 0) {
            data.maxTemperature = null;
        }
        this.objectMapping(sourceData, data);
    }

    mapFreightClassValue(itemClassList: any, value: any) {
        const data = _.find(itemClassList, ['itemClassName', String(value)]);
        if (data) {
            return data.itemClassName;
        }
        return null;
    }

    mapValueAndFreightClassField(list: any, nestedItem: boolean) {
        if (nestedItem) {
            list.items.filter((item: any) => {
                if (item.value && item.value.toString().includes('.00')) {
                    const value = item.value.toString();
                    item.value = value.replace('.00', '');
                }
                if (item.freightClass && item.freightClass.toString().includes('.0')) {
                    const freightClass = item.freightClass.toString();
                    item.freightClass = freightClass.replace('.0', '');
                    list.tempFreightClass = list.freightClass;
                }
            });
        } else {
            if (list.value && list.value.toString().includes('.00')) {
                const value = list.value.toString();
                list.value = value.replace('.00', '');
            }
            if (list.freightClass && list.freightClass.toString().includes('.0')) {
                const freightClass = list.freightClass.toString();
                list.freightClass = freightClass.replace('.0', '');
                list.tempFreightClass = list.freightClass;
            }
        }
    }

    prepareClassBreakDensityList(classBreaksList: any) {
        let classValue = [];
        let densityValue = [];
        let classDensityBreakList = [];
        const classBreaksListstr = classBreaksList.split(',');
        classBreaksListstr.map((x) => {
            const substring = x.split(',');
            const substringArray = substring[0];
            if (substring[0].includes('(')) {
                const result = substringArray.replace('(', '');
                classValue.push(result);
            }

            if (substring[0].includes(')')) {
                const result = substringArray.replace(')', '');
                densityValue.push(result);
            }
        })

        for (let i = 0; i < classValue.length; i++) {
            classDensityBreakList[i] = { class: densityValue[i], density: classValue[i] }
        }

        return classDensityBreakList;
    }

    setSuggestedClass(shipmentItems: any, classDensityBreaksList: any) {
        shipmentItems.map((item, parentIndex) => {
            item.items.map((value, index) => {
                if (value.quantity && value.weight && value.length && value.height && value.width) {
                    let classSuggested = false;
                    const density = shipmentItems[parentIndex].items[index].density;
                    if (!shipmentItems[parentIndex].items[index].tempFreightClass && classDensityBreaksList.length && !shipmentItems[parentIndex].items[index].isFreightClassSelected) {
                        const lastIndex = classDensityBreaksList.length - 1;
                        for (let i = 0; i < classDensityBreaksList.length; i++) {
                            if (!classSuggested && lastIndex != i && density >= classDensityBreaksList[i].density && density < classDensityBreaksList[i + 1].density) {
                                classSuggested = true;
                                shipmentItems[parentIndex].items[index].freightClass = classDensityBreaksList[i].class;
                                shipmentItems[parentIndex].items[index].suggestedFreightClass = classDensityBreaksList[i].class;
                            } else if (!classSuggested && lastIndex == i && density >= classDensityBreaksList[i].density) {
                                classSuggested = true;
                                shipmentItems[parentIndex].items[index].freightClass = classDensityBreaksList[i].class;
                                shipmentItems[parentIndex].items[index].suggestedFreightClass = classDensityBreaksList[i].class;
                            }
                        }
                    }
                }
            })
        })
    }

    getSelectedParcelRates(parcelResponse: any, selectedRate: any) {
        const selectedRatesList = [];
        parcelResponse.parcelRates.map((data: any) => {
            data.parcelRate.map((rate) => {
                const pos = selectedRate.selectedRates.findIndex((x) => x.id == rate.id);
                if (pos != -1) {
                    const rateIndex = data.parcelRate.findIndex((x) => x.id == selectedRate.selectedRates[pos].id);
                    if (rateIndex != -1) {
                        const obj = {
                            parcelItem: data.parcelItem,
                            parcelRate: data.parcelRate[rateIndex]
                        }
                        selectedRatesList.push(obj);
                    }
                }
            })
        })

        return selectedRatesList;
    }

    formatShipmentData(response: any): any {
        return {
            bolInstructions: this.cleanValue(response.BOLInstructions),
            ShipmentItems: this.getShipmentItemsMapping(response),
            originAddress: response.hasOwnProperty('OriginAddress') && response.OriginAddress ? this.formatAddress(response.OriginAddress, response) : {},
            destinationAddress: response.hasOwnProperty('DestinationAddress') && response.DestinationAddress ? this.formatAddress(response.DestinationAddress) : {},
            Services: response.Services || [],
            Equipments: response.Equipments || [],
            References: response.hasOwnProperty('References') && response.References ? this.mapReferences(response.References) : [],
            shipmentReferenceSettings: {
                referenceSettings: []
            },
            shipmentHandlingUnits: this.commonDataModel.shipmentMultiClassItems,
            shipmentServices: {
                services: []
            },
            shipmentEquipments: {
                equipments: []
            },

        };
    }

    getShipmentItemsMapping(response: any) {
        let list = [];
        if (response && response.ShipmentItems) {
            list = response.ShipmentItems.map((item: any) => ({
                id: null,
                weight: Number(this.cleanValue(item.Weight)) || null,
                quantity: Number(this.cleanValue(item.Quantity)),
                handlingType: this.cleanValue(item.HandlingType),
                packageType: this.cleanValue(item.HandlingType),
                pieces: this.cleanValue(this.extractNumericValue(item.Pieces)) || null,
                length: Number(this.cleanValue(item.Length)) || null,
                width: Number(this.cleanValue(item.Width)) || null,
                height: Number(this.cleanValue(item.Height)) || null,
                freightClass: this.freightClassValue(item.Class),
                nmfC_Code: this.cleanValue(item.NmfC_Code),
                itemId: this.cleanValue(item.ItemId),
                description: this.cleanValue(item.Description),
                value: Number(this.cleanValue(item.Value)),
                isHazmat: this.cleanValue(this.convertStringToLowerCase(item.IsHazmat)) == 'yes' || this.cleanValue(this.convertStringToLowerCase(item.IsHazmat)) == 'hazardous' || this.cleanValue(this.convertStringToLowerCase(item.IsHazmat)) == 'true' ? true : false,
                minPCF: 0,
                maxPCF: 0,
                uN_NA: "",
                hazMatClass: null,
                hazMatGroup: null,
                hazMatShipping: null,
                hazMatContactName: null,
                hazMatContactPhone: null,
                volume: 0,
                density: 0,
                searchBoxClass: null,
                searchBoxHandlingType: null,
                searchBoxPackageGroup: null,
                minLength: null,
                maxLength: null,
                tempFreightClass: null,
                isHandlingUnitSelected: true,
                isFreightClassSelected: false,
                suggestedFreightClass: null,
                isRequiredInsurance: false,
                isContainsDryIce: false,
                isContainsAlcohol: false,
                totalAmount: null,
                notes: '',
                itemCount: 1,
                totalAmountPerPackage: null,
                totalWeightValid: false,
                lengthValid: false,
                widthValid: false,
                heightValid: false,
                alcoholRecipientType: null,
                dryIceWeight: null,
                amountUpdated: false,
                perQuantityValue: null,
                searchBoxItem: null,
                commodityId: null,
                commodityCategory: null
            }))
        }

        return list;
    }

    mapReferences(references: any) {
        const list = [];
        if (isArray(references)) {
            return references.map(ref => {
                const mappedRef: any = {};
                for (const [key, value] of Object.entries(ref)) {
                    mappedRef[key] = this.cleanValue(value);
                }

                return mappedRef;
            });
        } else {
            const mappedRef: any = {};
            for (const [key, value] of Object.entries(references)) {
                mappedRef[key] = this.cleanValue(value);
            }
            list.push(mappedRef)
            return list;
        }
    }


    private cleanValue(value: any): string | null {
        if (value && typeof value === 'string' && value.trim().toLowerCase() === "not mentioned") {
            return null;
        } else if (typeof value === 'string') {
            return value.trim() || null;
        } else {
            return value;
        }
    }

    private freightClassValue(value: any): string | null {
        return value ? value.toString() : '';
    }

    formatAddress(address: any, shipmentData: any = null): any {
        return {
            loggedInOwnerId: this.commonService.getLoggedInOwnerId(),
            locationName: this.cleanValue(address && address.LocationName ? address.LocationName : ""),
            address1: this.cleanValue(address && address.Address1 ? address.Address1 : ""),
            address2: this.cleanValue(address && address.Address2 ? address.Address2 : ""),
            zipCode: this.cleanValue(address && address.ZipCode ? address.ZipCode : ""),
            countryCode: this.cleanValue(this.getStandardizedCountryCode(address && address.CountryCode ? address.CountryCode : "")),
            stateCode: this.cleanValue(address && address.StateCode ? address.StateCode : ""),
            stateName: this.cleanValue(address && address.StateCode ? address.StateCode : ""),
            city: this.cleanValue(address && address.City ? address.City : ""),
            contactName: this.cleanValue(address && address.ContactName ? address.ContactName : ""),
            phone: this.cleanValue(address && address.Phone ? address.Phone : ""),
            email: this.cleanValue(address && address.Email ? address.Email : ""),
            eventStartDateTime: "",
            contactId: null,
            id: null,
            updatedConsigneeInstruction: "",
            countryId: null,
            shippingEndTime: this.convertToISO(address && address.PickupDate && this.isValidDate(address.PickupDate) ? address.PickupDate : moment().format("MM/DD/YYYY"), address && address.ShippingEndTime ? address.ShippingEndTime : ''),
            shippingStartTime: this.convertToISO(address && address.PickupDate && this.isValidDate(address.PickupDate) ? address.PickupDate : moment().format("MM/DD/YYYY"), address && address.ShippingStartTime ? address.ShippingStartTime : ''),
            receivingEndTime: this.convertToISO(address && address.DeliveryDate && this.isValidDate(address.PickupDate) ? address.DeliveryDate : moment().add(1, "days").format("MM/DD/YYYY"), address && address.ReceivingEndTime ? address.ReceivingEndTime : ''),
            receivingStartTime: this.convertToISO(address && address.DeliveryDate && this.isValidDate(address.PickupDate) ? address.DeliveryDate : moment().add(1, "days").format("MM/DD/YYYY"), address && address.ReceivingStartTime ? address.ReceivingStartTime : ''),
            pickupDate: this.returnDates(address, address.PickupDate),
            deliveryDate: this.returnDates(address, address.DeliveryDate)
        };
    }

    getStandardizedCountryCode(countryCodeOrName?: string): string {
        if (!countryCodeOrName) {
            return "US"
        } else if (/^[A-Z]{2}$/.test(countryCodeOrName)) {
            return countryCodeOrName;
        } else {
            const countryMapping: { [key: string]: string } = {
                "United States": "US",
                "Canada": "CA",
                "Mexico": "MX"
            };

            return countryMapping[countryCodeOrName] ? countryMapping[countryCodeOrName] : "US";
        }
    }


    returnDates(address: any, date: any) {
        return address && date ? date : ''
    }

    convertToISO(pickupDate: string, time: string): string {
        if (!pickupDate || !time) return null;
        pickupDate = pickupDate.replace(/-/g, "/"); // Converts "DD-MM-YYYY" → "DD/MM/YYYY"
        const momentDate = moment(pickupDate, [
            "M/D/YYYY", "MM/D/YYYY", "M/DD/YYYY", "MM/DD/YYYY",
            "D/M/YYYY", "DD/M/YYYY", "D/MM/YYYY", "DD/MM/YYYY",
            "YYYY-MM-DD", "YYYY/MM/DD",
            "MMM D, YYYY", "MMMM D, YYYY",
            "D MMM YYYY", "D MMMM YYYY"
        ], true);  // `true` ensures strict parsing
        const dateObject = momentDate.format("DD/MM/YYYY");
        const [day, month, year] = dateObject.split("/").map(Number);
        const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

        // Normalize AM/PM format (Remove dots, trim spaces, convert to uppercase)
        let normalizedTime = time.replace(/\./g, '').trim().toUpperCase(); // "a.m." → "AM", "p.m." → "PM"

        // Match time format (12-hour with AM/PM or 24-hour without AM/PM)
        let timeMatch = normalizedTime.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
        if (!timeMatch) return null;

        let [_, hours, minutes, period] = timeMatch;
        let hour = parseInt(hours, 10);
        let minute = parseInt(minutes, 10);

        // Convert 12-hour format to 24-hour format if period exists
        if (period) {
            if (period === "PM" && hour !== 12) {
                hour += 12;
            } else if (period === "AM" && hour === 12) {
                hour = 0;
            }
        }

        // Handle 24-hour format input (no AM/PM provided)
        if (!period && hour >= 24) return null; // Invalid hour check
        return `${formattedDate}T${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}:00`;
    }


    getPickUpFromDate(address: any, datesObj: any) {
        if (isObject(datesObj)) {
            if (datesObj.hasOwnProperty('PickupFrom')) {
                return datesObj.PickupFrom;
            } else if (datesObj.hasOwnProperty('TimeFrom')) {
                return datesObj.TimeFrom;
            } else {
                return '';
            }
        } else {
            if (address.hasOwnProperty('PickupFrom')) {
                return address.PickupFrom;
            } else if (address.hasOwnProperty('TimeFrom')) {
                return address.TimeFrom;
            } else {
                return '';
            }
        }
    }

    getPickUpToDate(address: any, datesObj: any) {
        if (isObject(datesObj)) {
            if (datesObj.hasOwnProperty('PickupTo')) {
                return datesObj.PickupTo;
            } else if (datesObj.hasOwnProperty('TimeTo')) {
                return datesObj.TimeTo;
            } else {
                return '';
            }
        } else {
            if (address.hasOwnProperty('PickupTo')) {
                return address.PickupTo;
            } else if (address.hasOwnProperty('TimeTo')) {
                return address.TimeTo;
            } else {
                return '';
            }
        }
    }

    getPickUpDate(address: any, datesObj: any) {
        if (isObject(datesObj)) {
            if (datesObj.hasOwnProperty('PickupDate')) {
                return datesObj.PickupDate;
            } else if (datesObj.hasOwnProperty('Date')) {
                return datesObj.Date;
            } else {
                return '';
            }
        } else {
            if (address.hasOwnProperty('PickupDate')) {
                return address.PickupDate;
            } else if (address.hasOwnProperty('Date')) {
                return address.Date;
            } else {
                return '';
            }
        }
    }

    convertDateFormat(dateStr) {
        let parts = dateStr.split('/');
        return `${parts[1]}/${parts[0]}/${parts[2]}`; // Rearrange to MM/DD/YYYY
    }

    convertStringToLowerCase(value: any) {
        if (typeof (value) == 'string') {
            return value ? value.toLowerCase() : '';
        } else {
            return value ? value.toString() : '';
        }
    }

    extractNumericValue(value: any): number | null {
        const match = value && !isNumber(value) ? value.match(/\d+/) : value;
        return match ? parseInt(match) : null;
    }


    isValidDate(dateString) {
        const formats = [
            "M/D/YYYY", "MM/D/YYYY", "M/DD/YYYY", "MM/DD/YYYY",
            "D/M/YYYY", "DD/M/YYYY", "D/MM/YYYY", "DD/MM/YYYY",
            "YYYY-MM-DD", "YYYY/MM/DD",
            "MMM D, YYYY", "MMMM D, YYYY",
            "D MMM YYYY", "D MMMM YYYY"
        ];

        if (dateString.match(/^\d{1,2}\/\d{1,2}$/) || dateString.match(/^\d{1,2}-\d{1,2}$/)) {
            dateString += `/${new Date().getFullYear()}`;
        }

        return moment(dateString, formats, true).isValid();
    }


     transformError(err: any) {
        const messages: string[] = [];
        if (err) {
            Object.keys(err).map((key, index) => {
                messages.push(`${key}: ${err[key]}`);
            });
        }
        return messages;
    }

      onShowErrorMessage(errorMessages: any): void {
            let errorMessageTitle = CommonConstants.APICallCommon.errorMessageTitle;
    
            if (!Array.isArray(errorMessages)) {
                const data = this.transformError(errorMessages);
                errorMessages = data.toString();
            }
    
            if (errorMessages && errorMessages.length > 0) {
                errorMessageTitle = CommonConstants.APICallCommon.errorMessagePopupTitle;
            }
    
            const toast = this.toastr.error(errorMessages, errorMessageTitle, {
                timeOut: 0,
                extendedTimeOut: 0,
                tapToDismiss: false
            })
                .onTap
                .pipe(take(1))
                .subscribe((action) => this.onToastrClicked(errorMessages, toast.toastId));
        }
    
        onToastrClicked(errors: any, toastId: any): void {
            this.toastr.clear(toastId);
            const data: any = {
                message: errors, isList: true, title: 'Errors'
            };
    
            if (errors && errors.length === 0) {
                return;
            }
    
            data.message = errors;
            this.matDialog.open(CommonDialogComponent, {
                panelClass: 'confirm-dialog-wrapper',
                hasBackdrop: false,
                data: data || undefined,
            });
        }

}
